// 全域 Loading 狀態管理
import { reactive } from 'vue'

// Loading 狀態
export const loadingStore = reactive({
  isVisible: false,
  title: '分析中...',
  description: '請稍候，正在處理您的請求',
  progressText: '這可能需要幾分鐘時間',
  showTips: true,
  startTime: null,
  estimatedDuration: null
})

// 預設的 Loading 配置
const defaultConfigs = {
  ipp: {
    title: 'IPP四分衛環分析中...',
    description: '正在分析申請路線、攀登方式和縣市資料',
    progressText: '預估時間：30秒 - 2分鐘',
    estimatedDuration: 120000 // 2分鐘
  },
  turning: {
    title: '高轉折處計算中...',
    description: '正在分析GPX路線的高轉折點',
    progressText: '預估時間：1 - 3分鐘',
    estimatedDuration: 180000 // 3分鐘
  },
  step: {
    title: '步程推估中...',
    description: '正在推估搜救範圍的步程距離',
    progressText: '預估時間：1 - 3分鐘',
    estimatedDuration: 180000 // 3分鐘
  },
  hotspots: {
    title: '搜救熱區分析中...',
    description: '正在使用機器學習模型分析熱點區域',
    progressText: '預估時間：2 - 5分鐘',
    estimatedDuration: 300000 // 5分鐘
  },
  viewshed: {
    title: '視域分析中...',
    description: '正在進行視域分析計算',
    progressText: '預估時間：3 - 8分鐘',
    estimatedDuration: 480000 // 8分鐘
  },
  viewshedCombined: {
    title: '視域分析結合步程推估中...',
    description: '正在進行視域分析結合步程距離計算',
    progressText: '預估時間：5 - 10分鐘',
    estimatedDuration: 600000 // 10分鐘
  },
  expert: {
    title: '專家系統計算中...',
    description: '正在整合多項分析，產生智能搜救建議',
    progressText: '預估時間：2 - 5分鐘',
    estimatedDuration: 300000 // 5分鐘
  }
}

// 顯示 Loading
export function showLoading(type = 'default', customConfig = {}) {
  const config = type === 'default' ? {
    title: '處理中...',
    description: '請稍候，正在處理您的請求',
    progressText: '這可能需要一些時間',
    showTips: true
  } : { ...defaultConfigs[type], ...customConfig }

  loadingStore.isVisible = true
  loadingStore.title = config.title
  loadingStore.description = config.description
  loadingStore.progressText = config.progressText
  loadingStore.showTips = config.showTips !== false
  loadingStore.startTime = Date.now()
  loadingStore.estimatedDuration = config.estimatedDuration || null

  console.log(`🔄 顯示 Loading: ${config.title}`)
}

// 隱藏 Loading
export function hideLoading() {
  if (loadingStore.isVisible) {
    const duration = loadingStore.startTime ? Date.now() - loadingStore.startTime : 0
    console.log(`✅ Loading 完成，耗時: ${(duration / 1000).toFixed(1)}秒`)
  }
  
  loadingStore.isVisible = false
  loadingStore.startTime = null
  loadingStore.estimatedDuration = null
}

// 更新 Loading 訊息
export function updateLoadingMessage(title, description, progressText) {
  if (loadingStore.isVisible) {
    loadingStore.title = title
    loadingStore.description = description
    loadingStore.progressText = progressText
  }
}

// 獲取已等待時間
export function getElapsedTime() {
  if (!loadingStore.startTime) return 0
  return Date.now() - loadingStore.startTime
}

// 獲取剩餘預估時間
export function getRemainingTime() {
  if (!loadingStore.startTime || !loadingStore.estimatedDuration) return null
  const elapsed = getElapsedTime()
  const remaining = loadingStore.estimatedDuration - elapsed
  return Math.max(0, remaining)
}

// 檢查是否超時
export function isTimeout() {
  if (!loadingStore.startTime || !loadingStore.estimatedDuration) return false
  return getElapsedTime() > loadingStore.estimatedDuration
}

// 顯示錯誤 Loading
export function showErrorLoading(errorMessage) {
  loadingStore.isVisible = true
  loadingStore.title = '發生錯誤'
  loadingStore.description = errorMessage
  loadingStore.progressText = '請檢查網路連接或稍後再試'
  loadingStore.showTips = false
  loadingStore.startTime = null
  loadingStore.estimatedDuration = null
}

// 顯示成功 Loading
export function showSuccessLoading(message) {
  loadingStore.isVisible = true
  loadingStore.title = '完成！'
  loadingStore.description = message
  loadingStore.progressText = '檔案下載中...'
  loadingStore.showTips = false
  loadingStore.startTime = null
  loadingStore.estimatedDuration = null
}

// 自動隱藏 Loading（用於成功訊息）
export function autoHideLoading(delay = 2000) {
  setTimeout(() => {
    hideLoading()
  }, delay)
}

export default {
  loadingStore,
  showLoading,
  hideLoading,
  updateLoadingMessage,
  getElapsedTime,
  getRemainingTime,
  isTimeout,
  showErrorLoading,
  showSuccessLoading,
  autoHideLoading
}
